import { FlakinessReport } from '@flakiness/flakiness-report';
import { humanReadableMs } from '@flakiness/shared/common/utils.js';
import { LitElement, css, html, nothing } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { classMap } from 'lit/directives/class-map.js';
import { linkStyles } from './cssstyles.js';

@customElement('terminal-stdio')
class TerminalSTDIO extends LitElement {
  @property({ type: String }) attempt?: FlakinessReport.RunAttempt;

  render() {
    const stdio = this.attempt?.stdio;
    if (!this.attempt || !stdio)
      return nothing;
    let ts: number = this.attempt.startTimestamp ?? 0;
    return html`
      <fk-section id='section-terminal' open>
        <div slot="title">Terminal Output</div>
        <section>
          ${stdio.map(entry => {
            const txt = ('buffer' in entry) ? atob(entry.buffer) : entry.text;
            ts += entry.dts ?? 0;
            return html`
              <div class=${classMap({
                row: true,
                stderr: entry.stream === FlakinessReport.STREAM_STDERR,
              })}>
                ${entry.stream === FlakinessReport.STREAM_STDERR ?
                  html`<sl-icon class=stderr name=exclamation-triangle></sl-icon>` : html`<sl-icon class=stdout name=chevron-right></sl-icon>`
                }
                <ansi-text .text=${txt}></ansi-text>
                <span class=ts>${entry.dts === undefined ? '' : humanReadableMs(entry.dts)}</span>
              </div>
            `
          })}
        </section>
      </fk-section>
    `;
  }

  static styles = [linkStyles, css`
    fk-section::part(body) {
      padding: 0;
    }

    section {
      display: grid;
      grid-template-columns: auto 1fr auto;
      gap: 0 var(--sl-spacing-2x-small);
      position: relative;
      max-height: 350px;
      overflow: auto;

      & > .row {
        display: grid;
        grid-column: 1/-1;
        grid-template-columns: subgrid;
        padding: var(--sl-spacing-2x-small) var(--sl-spacing-2x-small);
        padding-right: var(--sl-spacing-medium);

        &:hover {
          background-color: var(--fk-color-tablerow-hover);
        }

        &.stderr {
          background-color: var(--sl-color-danger-50);
        }

        sl-icon.stderr {
          color: var(--sl-color-danger-600);
        }

        sl-icon.stdout {
          color: var(--sl-color-neutral-300);
        }
      }
    }

    .ts {
      justify-self: self-end;
      color: var(--sl-color-neutral-300);
    }

    section::after {
      content: "";
      position: sticky;
      grid-column: 1/-1;
      bottom: 0;
      display: block;
      height: 24px;
      background: linear-gradient(to bottom, transparent, white);
      pointer-events: none;
    }
  `];
}
